import React from 'react';
import PropTypes from 'prop-types';

/**
 * ThumbnailErrorBoundary - Provides fallback for failed thumbnails
 */
class ThumbnailErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error("ThumbnailErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="thumbnail-error-fallback">
          <div className="placeholder-play-button"></div>
          <div className="placeholder-text">
            <div>ASMR Video</div>
            <div>Unable to display thumbnail</div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ThumbnailErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default ThumbnailErrorBoundary;
